module.exports = "<!-- <app-rtionline-menu></app-rtionline-menu> -->\r\n<div class=\"clearfix\"></div>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/rtionline/rtionline.component.html
// module id = ./src/app/rtionline/rtionline.component.html
// module chunks = main